module.exports = __webpack_public_path__ + "6713614317379a7facfc9b7b1db84dd3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/new-realisations/xyz/city-walk/05.jpg
// module id = naS3
// module chunks = 0